import React, { Component } from 'react'
import { Alert, Modal, Overlay, ModalHeader, ModalButton } from './styles'
import closeIcon from '../../../static/close-icon.png'

class ModalDesligamento extends Component {
  state = {
    shouldShowModal: true
  }

  closeModal() {
    this.setState({
      shouldShowModal: false
    })
  }

  checkSessionStorage(key) {
    if (typeof sessionStorage !== 'undefined') {
      const data = sessionStorage.getItem(key)
      return data ? JSON.parse(data) : null
    }
    return null
  }

  writeSessionStorage(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data))
  }

  componentDidMount() {
    const modalHasBeenShown = this.checkSessionStorage('modalDesligamento')
    if (modalHasBeenShown) {
      this.setState({
        shouldShowModal: false
      })
    } else {
      this.writeSessionStorage('modalDesligamento', 'true')
    }
  }

  render() {
    const { shouldShowModal } = this.state
    if (!shouldShowModal) {
      return null
    }
    return (
      <Overlay>
        <Alert>
          <Modal>
            <ModalHeader>
              <button onClick={this.closeModal.bind(this)}>
                <img alt="close icon" src={closeIcon} />
              </button>
            </ModalHeader>
            <h1>Olá, parceiro (a)!</h1>
            <p>
              Estamos de mudança para uma casa nova, maior e com tudo que você precisa para
              gerenciar suas tags.
            </p>
            <p>
              Por isso, a partir de 20/07/2023 esse portal será desligado. Mas fique tranquilo(a),
              todas as funcionalidades já estão disponíveis no novo portal.
            </p>
            <ModalButton href="https://portal-parceiro.veloe.com.br">
              Acessar novo portal
            </ModalButton>
          </Modal>
        </Alert>
      </Overlay>
    )
  }
}

export default ModalDesligamento



// WEBPACK FOOTER //
// ./src/app/elements/ModalDesligamento/index.js